const FormTemplateKeys = {
  Suffix: 'FormKey',
};


/**
 * @param {HTMLFormElement} $form
 */
const getCustomFormControls = ($form) => {
  const $els = [...$form.elements];

  const keys = $els
    .filter($el => $el.name && $el.name.endsWith(FormTemplateKeys.Suffix))
    .map($el => $el.value);

  if (!keys.length) {
    return [];
  }

  return $els.filter($el => keys.some(key => $el.name.includes(key)));
};


export default getCustomFormControls;



// WEBPACK FOOTER //
// ./src/utils/form/getCustomFormControls.js